module.exports = __webpack_public_path__ + "img/email.248a9211.svg";